<script>
import { BIconArrowClockwise } from 'bootstrap-vue'
import VueSignaturePad from 'vue-signature-pad'
var canvas = document.getElementById('signature')

function resizeCanvas() {
  // When zoomed out to less than 100%, for some very strange reason,
  // some browsers report devicePixelRatio as less than 1
  // and only part of the canvas is cleared then.
  var ratio = Math.max(window.devicePixelRatio || 1, 1)
  canvas.width = canvas.offsetWidth * ratio
  canvas.height = canvas.offsetHeight * ratio
  canvas.getContext('2d').scale(ratio, ratio)
}
window.onresize = resizeCanvas
// resizeCanvas()
export default {
  name: 'FormSignature',
  components: {
    BIconArrowClockwise,
    VueSignaturePad,
  },
  props: {
    signature: {
      type: String,
      default: 'name',
    },
  },
  data: () => ({
    options: {
      penColor: '#c0f',
    },
    canvas: null,
  }),
  mounted() {},
  beforeDestroy() {
    var doc = this.$refs.signature
    if (doc !== undefined) doc.innerHTML = ''
  },
  methods: {
    b64toBlob(b64Data, contentType, sliceSize) {
      contentType = contentType || ''
      sliceSize = sliceSize || 512

      var byteCharacters = atob(b64Data)
      var byteArrays = []

      for (
        var offset = 0;
        offset < byteCharacters.length;
        offset += sliceSize
      ) {
        var slice = byteCharacters.slice(offset, offset + sliceSize)

        var byteNumbers = new Array(slice.length)
        for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i)
        }

        var byteArray = new Uint8Array(byteNumbers)

        byteArrays.push(byteArray)
      }

      var blob = new Blob(byteArrays, { type: contentType })
      //  var blob = new File(byteArrays, 'candidate-signature.png', {
      //       type: contentType,
      //    })
      return blob
    },

    undo() {
      this.$refs.signaturePad.undoSignature()
    },
    save() {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature()

      //    alert('Open DevTools see the save data.')
      //   console.log(isEmpty)
      //   console.log(data)
      if (!isEmpty) {
        var ImageURL = data
        // Split the base64 string in data and contentType
        this.$emit('image', data)
        var block = ImageURL.split(';')
        // Get the content type of the image
        var contentType = block[0].split(':')[1] // In this case "image/gif"
        // get the real base64 content of the file
        var realData = block[1].split(',')[1] // In this case "R0lGODlhPQBEAPeoAJosM...."

        // Convert it to a blob to upload
        //   console.log(realData)
        this.$emit('base', realData)
        var blob = this.b64toBlob(realData, contentType)

        this.$emit('data', blob)
      }
    },
    change() {
      this.$refs.signaturePad.clearSignature()
      //  this.$emit('data', null)
      //  this.$emit('base', null)
    },
    resume() {
      this.options = {
        penColor: '#c0f',
      }
    },
  },
}
</script>
<template>
  <div ref="signature">
    <div :class="$style.signatureWrap">
      <div :class="$style.undoIcon" class="h5 mb-0" @click="undo">
        <BIconArrowClockwise></BIconArrowClockwise>
      </div>
      <div id="app">
        <div>
          <VueSignaturePad
            id="signature"
            ref="signaturePad"
            width="100%"
            height="200px"
            :options="{
              onBegin: () => {
                $refs.signaturePad.resizeCanvas()
              },
            }"
          />
        </div>
      </div>
    </div>
    <div :class="[$style.buttonWrapper, $style.tc, $style.mt20]">
      <button
        class="buttonCommon buttonCancel button mr20 mb20-xs"
        @click="change"
      >
        Clear
      </button>
      <button class="buttonCommon buttonPrimary button" @click="save">
        <span>Done</span>
      </button>
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.undoIcon {
  position: absolute;
  top: 7px;
  right: 7px;
  width: 30px;
  height: 30px;
  padding: 3px 5px;
  font-weight: 500;
  color: #fff;
  cursor: pointer;
  background: #00d48d;
  border-radius: 50px;
}

.signatureWrap {
  position: relative;
  min-height: 150px;
  padding: 10px;
  background: #fafafa;
  border: 1px solid #eee;
  border-radius: 10px;
}
</style>
